import { fabric } from 'fabric';
import { useEffect, useRef } from 'react';

interface UseCanvasHandlersProps {
  canvas: fabric.Canvas;
  enabled: boolean;
  onEnableChange?: (enabled: boolean) => void;
  onMouseDown: (event: fabric.IEvent<MouseEvent>) => void;
  onMouseMove: (event: fabric.IEvent<MouseEvent>) => void;
  onMouseUp: (event: fabric.IEvent<MouseEvent>) => void;
}

export const useCanvasHandlers = (
  { canvas, enabled, onEnableChange, onMouseDown, onMouseMove, onMouseUp }: UseCanvasHandlersProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies?: any[],
) => {
  const mouseDownHandler = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => onMouseDown(event));
  const mouseMoveHandler = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => onMouseMove(event));
  const mouseUpHandler = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => onMouseUp(event));

  useEffect(() => {
    mouseDownHandler.current = (event) => onMouseDown(event);
  }, [onMouseDown]);

  useEffect(() => {
    mouseMoveHandler.current = (event) => onMouseMove(event);
  }, [onMouseMove]);

  useEffect(() => {
    mouseUpHandler.current = (event) => onMouseUp(event);
  }, [onMouseUp]);

  // stable refernces to event handlers to be possible to remove them canvas one by one,
  // not all for all canvas
  const handleMouseDown = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => mouseDownHandler.current(event));
  const handleMouseMove = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => mouseMoveHandler.current(event));
  const handleMouseUp = useRef<(e: fabric.IEvent<MouseEvent>) => void>((event) => mouseUpHandler.current(event));

  useEffect(() => {
    onEnableChange?.(enabled);

    canvas.off('mouse:down', handleMouseDown.current as (e: fabric.IEvent) => void);
    canvas.off('mouse:move', handleMouseMove.current as (e: fabric.IEvent) => void);
    canvas.off('mouse:up', handleMouseUp.current as (e: fabric.IEvent) => void);

    if (enabled) {
      canvas.on('mouse:down', handleMouseDown.current);
      canvas.on('mouse:move', handleMouseMove.current);
      canvas.on('mouse:up', handleMouseUp.current);
    }
  }, [canvas, enabled, onEnableChange, dependencies]);
};
